import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import AdminCompletion from './Register/Completions/AdminCompletion';
import InviteCompletion from './Register/Completions/InviteCompletion';
import BrityHeader from './Register/FormAtoms/BrityHeader';
import BrityFooter from './Register/FormAtoms/BrityFooter';

export const Compltion = ({ svcType }) => {
  const { menu } = useParams();
  const makeCompletionComponent = () => {
    let getComponent = '';
    switch (menu) {
      case 'admin':
        getComponent = <AdminCompletion svcType={svcType} />;
        break;
      case 'invitation':
        getComponent = <InviteCompletion />;
        break;
      case 'account':
        getComponent = <InviteCompletion />;
        break;
      case 'instant':
        getComponent = <InviteCompletion />;
        break;
      default:
        break;
    }
    return getComponent;
  };
  return (
    <>
      <BrityHeader />
      {makeCompletionComponent()}
      <BrityFooter />
    </>
  );
};
Compltion.propTypes = { svcType: PropTypes.string };
Compltion.defaultProps = { svcType: null };
export default Compltion;
